"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterPopover = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var _1 = require(".");
var svgs_1 = require("../assets/svgs");
var FilterPopover = function (_a) {
    var filters = _a.filters, setFilters = _a.setFilters;
    var _b = (0, react_1.useState)(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var open = Boolean(anchorEl);
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    return ((0, jsx_runtime_1.jsxs)(_1.Stack, __assign({ direction: "row", justifyContent: "start", spacing: "2.0rem" }, { children: [(0, jsx_runtime_1.jsx)(_1.IconButton, __assign({ id: "basic-button", "aria-controls": "basic-menu", "aria-haspopup": "true", "aria-expanded": open ? 'true' : undefined, onClick: function (e) { return handleClick(e); }, sx: {
                    width: '4.8rem',
                    height: '4.8rem',
                    color: 'rgba(255,255,255,0.4)',
                    border: '2px',
                    backgroundColor: Object.values(filters).some(function (i) {
                        return i.isChecked === true;
                    })
                        ? 'primary.main'
                        : '#292954',
                    borderRadius: 9999,
                    minWidth: 0,
                    '&:hover': {
                        borderColor: 'primary.main',
                        backgroundColor: 'primary.main',
                        color: 'common.white',
                    },
                } }, { children: (0, jsx_runtime_1.jsx)(svgs_1.Filter, {}) })), (0, jsx_runtime_1.jsxs)(_1.Popover, __assign({ open: open, anchorEl: anchorEl, onClose: handleClose, elevation: 4, PaperProps: {
                    style: {
                        borderRadius: '2.0rem',
                        backgroundColor: 'transparent',
                        boxShadow: 'rgb(145 158 171 / 24%) 0px 12px 24px 0px',
                    },
                }, sx: {
                    marginTop: '1.8rem',
                    paddingTop: 0,
                    '& .MuiPopover-paper': {
                        marginTop: '-2rem',
                        marginLeft: '-2.2rem',
                    },
                }, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                } }, { children: [(0, jsx_runtime_1.jsx)(_1.Box, { sx: {
                            position: 'relative',
                            mt: '10px',
                            '&:before': {
                                content: '""',
                                display: 'block',
                                width: 0,
                                height: 0,
                                borderLeft: '1rem solid transparent',
                                borderRight: '1rem solid transparent',
                                borderBottom: '1rem solid white',
                                marginLeft: '3.8rem',
                            },
                        } }), (0, jsx_runtime_1.jsxs)(_1.Box, __assign({ sx: {
                            padding: '2.8rem',
                            width: '30rem',
                            backgroundColor: 'common.white',
                            borderRadius: '2rem',
                            boxShadow: 'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 12px 24px 0px',
                        } }, { children: [(0, jsx_runtime_1.jsx)(_1.Typography, __assign({ component: "p", variant: "bodyMedium", sx: { lineHeight: 1, marginBottom: '1.8rem' } }, { children: "Status" })), (0, jsx_runtime_1.jsx)(_1.CheckboxList, { filters: filters, onChange: function (e, label) {
                                    var _a;
                                    setFilters(__assign(__assign({}, filters), (_a = {}, _a[e.target.name] = {
                                        label: label,
                                        isChecked: e.target.checked,
                                    }, _a)));
                                } })] }))] }))] })));
};
exports.FilterPopover = FilterPopover;
